import React from 'react';
import { Text, View } from 'react-native';
import Unicon from '@/components/General/Unicon';
import { serviceFlowStyles } from './serviceFlowStyles';

/**
 * Worship set — honest Part 1 placeholder (spec §4.4/§12.2). No song editor,
 * no fake task, no arbitrary music JSON. The item's stable UUID is the future
 * attachment point for a normalized WorshipSets relationship.
 */
const ServiceFlowWorshipSummary = () => (
    <View style={serviceFlowStyles.worshipPlaceholder}>
        <Unicon name="musical-notes-outline" size={16} colorVariant="events" />
        <Text style={serviceFlowStyles.worshipPlaceholderText}>
            Set details coming later — songs and positions are part of a future update.
        </Text>
    </View>
);

export default ServiceFlowWorshipSummary;
